export default __webpack_public_path__ + "static/media/PowerPoleWallDouble_MK2.256.5fcb92a0.png";